<template>
  <head>
    <meta charset="utf-8" />
    <title>CBHI | Community-Based Health Insurance</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Registered Hospitals</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Hospitals Register</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Hospital Statistics Dashboard -->
          <div class="row">
            <!-- Total Hospitals -->
            <div class="col-lg-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Hospitals</p>
                      <h5 class="mb-0">{{ statistics.totalHospitals }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-building-house"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Active Hospitals -->
            <div class="col-lg-3 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Active Hospitals</p>
                      <h5 class="mb-0">{{ statistics.activeHospitals }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-check-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Government Hospitals -->
            <div class="col-lg-3 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Government</p>
                      <h5 class="mb-0">{{ statistics.governmentHospitals }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-purple rounded-circle text-white font-size-20">
                        <i class="bx bx-buildings"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 24/7 Emergency Services -->
            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">24/7 Emergency</p>
                      <h5 class="mb-0">{{ statistics.emergencyServices }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="bx bx-cross"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Average Bed Capacity -->
            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Avg Bed Capacity</p>
                      <h5 class="mb-0">{{ statistics.avgBedCapacity }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-teal rounded-circle text-white font-size-20">
                        <i class="bx bx-bed"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center w-100 border-bottom-1 pb-3 border-bottom-1 border-bottom">
                  <!-- Alert Messages -->
                  <div class="col-12 mb-3" v-if="alert.success || alert.info || alert.failed">
                    <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                      <i class="mdi mdi-check-all me-2"></i>
                      {{ message }}
                      <button type="button" class="btn-close" @click="clearAlerts"></button>
                    </div>

                    <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                      <i class="mdi mdi-information me-2"></i>
                      {{ message }}
                      <button type="button" class="btn-close" @click="clearAlerts"></button>
                    </div>

                    <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                      <i class="mdi mdi-alert-outline me-2"></i>
                      {{ message }}
                      <button type="button" class="btn-close" @click="clearAlerts"></button>
                    </div>
                  </div>

                  <div class="btn-toolbar d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input
                              type="text"
                              v-model="searchTerm"
                              @input="performSearch"
                              @keyup="performSearch"
                              class="form-control bg-light border-light rounded"
                              placeholder="Search hospitals, locations..."
                              spellcheck="false"
                          >
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <router-link to="/hospitals-add" class="btn btn-success me-2">
                        <i class="bx bx-plus"></i>
                        <span class="pl-1 d-md-inline">Add Hospital</span>
                      </router-link>
                      <button @click="exportData" type="button" class="btn btn-primary dropdown-toggle option-selector text-capitalize">
                        <i class="bx bxs-download"></i>
                        <span class="pl-1 d-md-inline">Export Data</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3">Loading hospitals...</p>
                  </div>

                  <!-- Empty State -->
                  <div v-else-if="!loading && filteredHospitals.length === 0" class="text-center py-5">
                    <i class="bx bx-building-house display-1 text-muted"></i>
                    <h5 class="mt-3">No Hospitals Found</h5>
                    <p class="text-muted">{{ searchTerm ? 'Try adjusting your search criteria' : 'No hospitals have been registered yet' }}</p>
                  </div>

                  <!-- Hospitals Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table border table-striped text-nowrap" id="hospitalsTable">
                      <thead class="table-light">
                      <tr>
                        <th>Hospital</th>
                        <th>Location</th>
                        <th>Category</th>
                        <th>Contact</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="hospital in paginatedHospitals" :key="hospital.hospital_id">
                        <td>
                          <div class="d-flex align-items-center">
                            <div>
                              <div class="hospital-name fw-semibold">{{ hospital.hospital_name || 'N/A' }}</div>
                              <small class="text-muted">License: {{ hospital.license_number || 'N/A' }}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="location-text">
                            <i class="fas fa-map-marker-alt me-1"></i>
                            {{ hospital.region_name || 'N/A' }}<br>
                            <small>{{ hospital.zone_name || 'N/A' }}, {{ hospital.woreda_name || 'N/A' }}</small>
                          </div>
                        </td>
                        <td>
                              <span :class="getCategoryBadgeClass(hospital.category_name)">
                                {{ hospital.category_name || 'N/A' }}
                              </span>
                        </td>
                        <td>
                          <div class="contact-info">
                            <div><i class="fas fa-phone me-1"></i>{{ hospital.primary_phone || 'N/A' }}</div>
                            <div v-if="hospital.hospital_email">
                              <i class="fas fa-envelope me-1"></i>{{ hospital.hospital_email }}
                            </div>
                          </div>
                        </td>
                        <td>
                              <span :class="getStatusBadgeClass(hospital.status)">
                                {{ hospital.status || 'N/A' }}
                              </span>
                        </td>
                        <td class="table-actions">
                          <div class="dropdown">
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button"
                                    :id="`dropdownMenu${hospital.hospital_id}`"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                              <i class="bx bx-dots-vertical-rounded"></i> Actions
                            </button>
                            <ul class="dropdown-menu" :aria-labelledby="`dropdownMenu${hospital.hospital_id}`">
                              <li>
                                <a class="dropdown-item" href="javascript:void(0)" @click="viewDetails(hospital)">
                                  <i class="bx bx-show me-2"></i>View Details
                                </a>
                              </li>
                              <li>
                                <a class="dropdown-item" href="javascript:void(0)" @click="editHospital(hospital)">
                                  <i class="bx bx-edit me-2"></i>Edit Hospital
                                </a>
                              </li>
                              <li>
                                <a class="dropdown-item" href="javascript:void(0)" @click="showApiCredentialsModal(hospital)">
                                  <i class="bx bx-key me-2"></i>API Credentials
                                </a>
                              </li>
                              <li><hr class="dropdown-divider"></li>
                              <li>
                                <a class="dropdown-item text-danger" href="javascript:void(0)" @click="confirmDelete(hospital)">
                                  <i class="bx bx-trash me-2"></i>Delete Hospital
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="!loading && filteredHospitals.length > 0" class="row mt-4">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info">
                        Showing {{ startRecord }} to {{ endRecord }} of {{ filteredHospitals.length }} entries
                        <span v-if="searchTerm">(filtered from {{ hospitals.length }} total entries)</span>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination">
                          <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 1 }">
                            <a @click="previousPage" class="page-link">Previous</a>
                          </li>
                          <li
                              v-for="page in displayedPages"
                              :key="page"
                              class="paginate_button page-item"
                              :class="{ active: currentPage === page }"
                          >
                            <a @click="goToPage(page)" class="page-link">{{ page }}</a>
                          </li>
                          <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages }">
                            <a @click="nextPage" class="page-link">Next</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- API Credentials Modal -->
      <div class="modal fade" id="apiCredentialsModal" tabindex="-1" aria-labelledby="apiCredentialsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white" id="apiCredentialsModalLabel">
                <i class="bx bx-key me-2"></i>
                API Credentials Management
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" v-if="selectedHospitalForCredentials">
              <div class="card bg-light mb-3">
                <div class="card-body">
                  <h6 class="card-title">{{ selectedHospitalForCredentials.hospital_name }}</h6>
                  <p class="card-text mb-1">
                    <small class="text-muted">Hospital ID:</small> <strong>{{ selectedHospitalForCredentials.hospital_id }}</strong>
                  </p>
                  <p class="card-text mb-1">
                    <small class="text-muted">License Number:</small> <strong>{{ selectedHospitalForCredentials.license_number }}</strong>
                  </p>
                  <p class="card-text">
                    <small class="text-muted">Contact Email:</small> <strong>{{ selectedHospitalForCredentials.hospital_email || 'No email registered' }}</strong>
                  </p>
                </div>
              </div>

              <div class="alert alert-info" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <strong>Note:</strong> API credentials allow the hospital to integrate with the CBHI system programmatically.
              </div>

              <div class="mb-3">
                <label for="credentialAction" class="form-label">Select Action:</label>
                <select v-model="credentialAction" class="form-select" id="credentialAction">
                  <option value="resend">Resend Existing Credentials (New Secret)</option>
                  <option value="regenerate">Regenerate New Credentials (Invalidates Old)</option>
                </select>
              </div>

              <div class="mb-3">
                <label for="reason" class="form-label">Reason for this action:</label>
                <textarea v-model="credentialReason" class="form-control" id="reason" rows="2"
                          placeholder="e.g., Lost credentials, security update, compromised keys..."></textarea>
              </div>

              <div v-if="!selectedHospitalForCredentials.hospital_email" class="alert alert-warning" role="alert">
                <i class="bx bx-error me-2"></i>
                <strong>Warning:</strong> This hospital doesn't have an email registered. Credentials will only be shown here.
              </div>

              <!-- Success Message with Credentials -->
              <div v-if="credentialsResponse" class="mt-4">
                <div class="alert alert-success" role="alert">
                  <i class="bx bx-check-circle me-2"></i>
                  Credentials {{ credentialAction === 'regenerate' ? 'regenerated' : 'resent' }} successfully!
                  <span v-if="credentialsResponse.emailSent">An email has been sent to {{ selectedHospitalForCredentials.hospital_email }}</span>
                </div>

                <div class="card border-success">
                  <div class="card-header bg-success text-white">
                    <i class="bx bx-lock-open me-2"></i>API Credentials
                  </div>
                  <div class="card-body">
                    <div class="mb-3">
                      <label class="form-label text-muted small">API Key</label>
                      <div class="input-group">
                        <input type="text" class="form-control font-monospace" :value="credentialsResponse.apiKey" readonly>
                        <button class="btn btn-outline-secondary" type="button" @click="copyToClipboard(credentialsResponse.apiKey, 'API Key')">
                          <i class="bx bx-copy"></i>
                        </button>
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="form-label text-muted small">API Secret</label>
                      <div class="input-group">
                        <input :type="showApiSecret ? 'text' : 'password'" class="form-control font-monospace"
                               :value="credentialsResponse.apiSecret || '[Sent via email]'" readonly>
                        <button class="btn btn-outline-secondary" type="button" @click="showApiSecret = !showApiSecret">
                          <i :class="showApiSecret ? 'bx bx-hide' : 'bx bx-show'"></i>
                        </button>
                        <button v-if="credentialsResponse.apiSecret" class="btn btn-outline-secondary" type="button"
                                @click="copyToClipboard(credentialsResponse.apiSecret, 'API Secret')">
                          <i class="bx bx-copy"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="resetCredentialsModal">Close</button>
              <button v-if="!credentialsResponse" type="button" class="btn btn-primary" @click="resendApiCredentials"
                      :disabled="sendingCredentials || !selectedHospitalForCredentials">
                <span v-if="sendingCredentials">
                  <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                  Processing...
                </span>
                <span v-else>
                  <i class="bx bx-send me-2"></i>
                  {{ credentialAction === 'regenerate' ? 'Regenerate' : 'Resend' }} Credentials
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Copy Toast Notification -->
      <div class="position-fixed top-0 end-0 p-3" style="z-index: 11">
        <div id="copyToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
          <div class="toast-body bg-success text-white">
            <i class="bx bx-check me-2"></i>
            {{ copyMessage }} copied to clipboard!
          </div>
        </div>
      </div>

      <!-- Hospital Details Modal -->
      <div class="modal fade" id="hospitalDetailsModal" tabindex="-1" aria-labelledby="hospitalDetailsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="hospitalDetailsModalLabel">
                <i class="bx bx-building-house me-2"></i>
                Hospital Details
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" v-if="selectedHospital">
              <div class="row">
                <!-- Basic Information -->
                <div class="col-md-6">
                  <h6 class="text-primary mb-3">Basic Information</h6>
                  <table class="table table-borderless">
                    <tr>
                      <td class="text-muted">Hospital Name:</td>
                      <td class="fw-semibold">{{ selectedHospital.hospital_name || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted">License Number:</td>
                      <td class="fw-semibold">{{ selectedHospital.license_number || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted">Category:</td>
                      <td class="fw-semibold">{{ selectedHospital.category_name || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted">Ownership:</td>
                      <td class="fw-semibold">{{ selectedHospital.ownership_name || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted">Bed Capacity:</td>
                      <td class="fw-semibold">{{ selectedHospital.bed_capacity || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted">Registration Date:</td>
                      <td class="fw-semibold">{{ formatDate(selectedHospital.registration_date) }}</td>
                    </tr>
                  </table>
                </div>

                <!-- Location Information -->
                <div class="col-md-6">
                  <h6 class="text-primary mb-3">Location Information</h6>
                  <table class="table table-borderless">
                    <tr>
                      <td class="text-muted">Region:</td>
                      <td class="fw-semibold">{{ selectedHospital.region_name || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted">Zone:</td>
                      <td class="fw-semibold">{{ selectedHospital.zone_name || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted">Woreda:</td>
                      <td class="fw-semibold">{{ selectedHospital.woreda_name || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted">Physical Address:</td>
                      <td class="fw-semibold">{{ selectedHospital.physical_address || 'N/A' }}</td>
                    </tr>
                    <tr v-if="selectedHospital.postal_address">
                      <td class="text-muted">Postal Address:</td>
                      <td class="fw-semibold">{{ selectedHospital.postal_address }}</td>
                    </tr>
                  </table>
                </div>

                <!-- Contact Information -->
                <div class="col-md-6 mt-3">
                  <h6 class="text-primary mb-3">Contact Information</h6>
                  <table class="table table-borderless">
                    <tr>
                      <td class="text-muted">Primary Phone:</td>
                      <td class="fw-semibold">{{ selectedHospital.primary_phone || 'N/A' }}</td>
                    </tr>
                    <tr v-if="selectedHospital.secondary_phone">
                      <td class="text-muted">Secondary Phone:</td>
                      <td class="fw-semibold">{{ selectedHospital.secondary_phone }}</td>
                    </tr>
                    <tr v-if="selectedHospital.hospital_email">
                      <td class="text-muted">Email:</td>
                      <td class="fw-semibold">{{ selectedHospital.hospital_email }}</td>
                    </tr>
                    <tr v-if="selectedHospital.website">
                      <td class="text-muted">Website:</td>
                      <td class="fw-semibold">
                        <a :href="selectedHospital.website" target="_blank">{{ selectedHospital.website }}</a>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-muted">Contact Person:</td>
                      <td class="fw-semibold">{{ selectedHospital.contact_person || 'N/A' }}</td>
                    </tr>
                    <tr v-if="selectedHospital.contact_person_position">
                      <td class="text-muted">Position:</td>
                      <td class="fw-semibold">{{ selectedHospital.contact_person_position }}</td>
                    </tr>
                  </table>
                </div>

                <!-- Special Features -->
                <div class="col-md-6 mt-3">
                  <h6 class="text-primary mb-3">Special Features</h6>
                  <div class="d-flex flex-wrap gap-2">
                      <span v-if="selectedHospital.emergency_services == 1" class="badge bg-danger">
                        <i class="bx bx-cross me-1"></i>24/7 Emergency
                      </span>
                    <span v-if="selectedHospital.referral_center == 1" class="badge bg-info">
                        <i class="bx bx-transfer me-1"></i>Referral Center
                      </span>
                    <span v-if="selectedHospital.ambulance_available == 1" class="badge bg-warning">
                        <i class="bx bx-car me-1"></i>Ambulance Available
                      </span>
                  </div>

                  <div class="mt-3">
                    <p class="text-muted mb-1">Operating Hours:</p>
                    <p class="fw-semibold">{{ selectedHospital.operating_hours || 'Not specified' }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" @click="editHospital(selectedHospital)">
                <i class="bx bx-edit me-2"></i>Edit Hospital
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Confirmation Modal -->
      <div class="modal fade" id="deleteConfirmationModal" tabindex="-1" aria-labelledby="deleteConfirmationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title text-white" id="deleteConfirmationModalLabel">
                <i class="bx bx-warning me-2"></i>
                Confirm Hospital Deletion
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" v-if="hospitalToDelete">
              <div class="alert alert-danger" role="alert">
                <i class="bx bx-error-circle me-2"></i>
                <strong>Warning!</strong> This action cannot be undone.
              </div>

              <p class="mb-3">
                You are about to permanently delete the following hospital:
              </p>

              <div class="card bg-light">
                <div class="card-body">
                  <h6 class="card-title mb-2">{{ hospitalToDelete.hospital_name }}</h6>
                  <p class="card-text mb-1">
                    <small class="text-muted">License Number:</small>
                    <strong>{{ hospitalToDelete.license_number }}</strong>
                  </p>
                  <p class="card-text mb-1">
                    <small class="text-muted">Location:</small>
                    {{ hospitalToDelete.region_name }}, {{ hospitalToDelete.zone_name }}
                  </p>
                  <p class="card-text mb-0">
                    <small class="text-muted">Contact:</small>
                    {{ hospitalToDelete.primary_phone }}
                  </p>
                </div>
              </div>

              <div class="mt-4">
                <p class="mb-2">
                  <strong>To confirm deletion, please type <span class="text-danger">"DELETE"</span> in the box below:</strong>
                </p>
                <div class="form-group">
                  <input
                      type="text"
                      v-model="deleteConfirmationText"
                      @input="checkDeleteConfirmation"
                      class="form-control"
                      :class="{ 'is-invalid': deleteConfirmationText && !isDeleteConfirmed, 'is-valid': isDeleteConfirmed }"
                      placeholder="Type DELETE to confirm"
                      autocomplete="off"
                  >
                  <div v-if="deleteConfirmationText && !isDeleteConfirmed" class="invalid-feedback">
                    Please type "DELETE" exactly as shown above.
                  </div>
                </div>
              </div>

              <div class="mt-3">
                <small class="text-muted">
                  <i class="bx bx-info-circle me-1"></i>
                  This will permanently remove all hospital data and associated records.
                </small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="resetDeleteModal">
                Cancel
              </button>
              <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteHospital"
                  :disabled="!isDeleteConfirmed || deleting"
              >
                <span v-if="deleting">
                  <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                  Deleting...
                </span>
                <span v-else>
                  <i class="bx bx-trash me-2"></i>
                  Delete Hospital
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Ministry of Health - Ethiopia
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "HospitalsList",
  components: { NavigationBar },
  data() {
    return {
      loading: false,
      searchTerm: '',
      currentPage: 1,
      itemsPerPage: 10,
      searchTimeout: null, // For debouncing search

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',

      // Hospital data
      hospitals: [],
      filteredHospitals: [],
      selectedHospital: null,

      // API Credentials
      selectedHospitalForCredentials: null,
      credentialAction: 'resend',
      credentialReason: '',
      sendingCredentials: false,
      credentialsResponse: null,
      showApiSecret: false,
      copyMessage: '',

      // Delete confirmation
      hospitalToDelete: null,
      deleteConfirmationText: '',
      isDeleteConfirmed: false,
      deleting: false,

      // Statistics
      statistics: {
        totalHospitals: 0,
        activeHospitals: 0,
        governmentHospitals: 0,
        emergencyServices: 0,
        avgBedCapacity: 0
      },

      // Filters
      filters: {
        regionId: '',
        zoneId: '',
        categoryId: '',
        status: '',
        ownershipId: ''
      }
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.filteredHospitals.length / this.itemsPerPage);
    },

    paginatedHospitals() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredHospitals.slice(start, end);
    },

    startRecord() {
      return this.filteredHospitals.length === 0 ? 0 : ((this.currentPage - 1) * this.itemsPerPage) + 1;
    },

    endRecord() {
      const end = this.currentPage * this.itemsPerPage;
      return end > this.filteredHospitals.length ? this.filteredHospitals.length : end;
    },

    displayedPages() {
      const pages = [];
      const maxPages = 5;

      let startPage = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
      let endPage = Math.min(this.totalPages, startPage + maxPages - 1);

      if (endPage - startPage < maxPages - 1) {
        startPage = Math.max(1, endPage - maxPages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    }
  },

  mounted() {
    this.checkAuthentication();
    this.loadHospitals();
  },

  methods: {
    checkAuthentication() {
      const token = localStorage.getItem("authToken");
      if (!token) {
        router.push('/login');
      }
    },

    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      // Auto-hide success/info alerts after 5 seconds
      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    },

    async loadHospitals() {
      this.loading = true;
      this.showAlert('info', 'Loading hospitals...');

      try {
        const data = {
          function: "getHospitals",
          limit: 1000, // Get all hospitals
          offset: 0
        };

        // Add filters if set
        if (this.filters.regionId) data.regionId = this.filters.regionId;
        if (this.filters.zoneId) data.zoneId = this.filters.zoneId;
        if (this.filters.categoryId) data.categoryId = this.filters.categoryId;
        if (this.filters.status) data.status = this.filters.status;

        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.hospitals = response.data.data.hospitals || [];
          this.filteredHospitals = [...this.hospitals];
          this.calculateStatistics();
          this.clearAlerts();
        } else {
          this.showAlert('failed', response.data.message || 'Failed to load hospitals');
        }
      } catch (error) {
        console.error('Error loading hospitals:', error);
        this.showAlert('failed', error.message || 'Error loading hospitals');
      } finally {
        this.loading = false;
      }
    },

    calculateStatistics() {
      this.statistics.totalHospitals = this.hospitals.length;
      this.statistics.activeHospitals = this.hospitals.filter(h => h.status === 'active').length;

      // Count government hospitals
      this.statistics.governmentHospitals = this.hospitals.filter(h =>
          h.ownership_name === 'Government'
      ).length;

      // Count 24/7 emergency services
      this.statistics.emergencyServices = this.hospitals.filter(h =>
          h.emergency_services == 1
      ).length;

      // Calculate average bed capacity
      const hospitalsWithBeds = this.hospitals.filter(h => h.bed_capacity && h.bed_capacity > 0);
      if (hospitalsWithBeds.length > 0) {
        const totalBeds = hospitalsWithBeds.reduce((sum, h) => sum + parseInt(h.bed_capacity), 0);
        this.statistics.avgBedCapacity = Math.round(totalBeds / hospitalsWithBeds.length);
      }
    },

    // Safe string helper function
    safeString(value) {
      return value ? String(value).toLowerCase() : '';
    },

    performSearch() {
      // Clear existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Debounce search to avoid excessive filtering
      this.searchTimeout = setTimeout(() => {
        if (!this.searchTerm || this.searchTerm.trim() === '') {
          this.filteredHospitals = [...this.hospitals];
        } else {
          const search = this.searchTerm.toLowerCase().trim();
          this.filteredHospitals = this.hospitals.filter(hospital => {
            try {
              return this.safeString(hospital.hospital_name).includes(search) ||
                  this.safeString(hospital.license_number).includes(search) ||
                  this.safeString(hospital.region_name).includes(search) ||
                  this.safeString(hospital.zone_name).includes(search) ||
                  this.safeString(hospital.woreda_name).includes(search) ||
                  this.safeString(hospital.hospital_email).includes(search) ||
                  this.safeString(hospital.primary_phone).includes(search) ||
                  this.safeString(hospital.category_name).includes(search) ||
                  this.safeString(hospital.physical_address).includes(search) ||
                  this.safeString(hospital.contact_person).includes(search);
            } catch (error) {
              console.error('Error in search filter:', error, hospital);
              return false;
            }
          });
        }
        this.currentPage = 1; // Reset to first page when searching
      }, 300);
    },

    getCategoryBadgeClass(category) {
      if (!category) return 'badge bg-secondary';

      const categoryMap = {
        'Specialized Hospital': 'badge bg-danger',
        'General Hospital': 'badge bg-primary',
        'Primary Hospital': 'badge bg-success',
        'Health Center': 'badge bg-info',
        'University Hospital': 'badge bg-purple',
        'Referral Hospital': 'badge bg-secondary',
        'default': 'badge bg-secondary'
      };
      return categoryMap[category] || categoryMap['default'];
    },

    getStatusBadgeClass(status) {
      if (!status) return 'badge bg-secondary';

      const statusMap = {
        'active': 'badge bg-success',
        'inactive': 'badge bg-secondary',
        'suspended': 'badge bg-danger',
        'default': 'badge bg-secondary'
      };
      return statusMap[status] || statusMap['default'];
    },

    // API Credentials Methods
    showApiCredentialsModal(hospital) {
      this.selectedHospitalForCredentials = hospital;
      this.resetCredentialsModal();
      const modal = new bootstrap.Modal(document.getElementById('apiCredentialsModal'));
      modal.show();
    },

    resetCredentialsModal() {
      this.credentialAction = 'resend';
      this.credentialReason = '';
      this.credentialsResponse = null;
      this.showApiSecret = false;
      this.sendingCredentials = false;
    },

    async resendApiCredentials() {
      if (!this.selectedHospitalForCredentials) return;

      this.sendingCredentials = true;

      try {
        const data = {
          function: "resendHospitalApiCredentials",
          hospitalId: this.selectedHospitalForCredentials.hospital_id,
          regenerateCredentials: this.credentialAction === 'regenerate',
          forceNewSecret: this.credentialAction === 'resend',
          reason: this.credentialReason || 'Manual credential resend requested'
        };

        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.credentialsResponse = response.data.data;
          this.showAlert('success', `API credentials ${this.credentialAction === 'regenerate' ? 'regenerated' : 'resent'} successfully!`);
        } else {
          this.showAlert('failed', response.data.message || 'Failed to process API credentials');
        }
      } catch (error) {
        console.error('Error processing API credentials:', error);
        this.showAlert('failed', error.message || 'Error processing API credentials');
      } finally {
        this.sendingCredentials = false;
      }
    },

    copyToClipboard(text, label) {
      navigator.clipboard.writeText(text).then(() => {
        this.copyMessage = label;
        const toastEl = document.getElementById('copyToast');
        const toast = new bootstrap.Toast(toastEl, {
          delay: 2000
        });
        toast.show();
      }).catch(err => {
        console.error('Failed to copy: ', err);
        this.showAlert('failed', 'Failed to copy to clipboard');
      });
    },

    formatDate(date) {
      if (!date) return 'N/A';
      try {
        return new Date(date).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      } catch (error) {
        return 'N/A';
      }
    },

    viewDetails(hospital) {
      this.selectedHospital = hospital;
      const modal = new bootstrap.Modal(document.getElementById('hospitalDetailsModal'));
      modal.show();
    },

    closeAllModals() {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });
    },

    editHospital(hospital) {
      this.closeAllModals();

      // Store hospital data in sessionStorage for editing
      sessionStorage.setItem('editHospital', JSON.stringify(hospital));
      router.push({
        name: 'hospitals-edit',
        params: { id: hospital.hospital_id }
      });
    },

    async exportData() {
      this.showAlert('info', 'Preparing export...');

      try {
        // Create CSV content
        const headers = ['Hospital Name', 'License Number', 'Category', 'Region', 'Zone', 'Woreda', 'Phone', 'Email', 'Status'];
        const csvContent = [
          headers.join(','),
          ...this.filteredHospitals.map(h => [
            `"${h.hospital_name || ''}"`,
            h.license_number || '',
            h.category_name || '',
            h.region_name || '',
            h.zone_name || '',
            h.woreda_name || '',
            h.primary_phone || '',
            h.hospital_email || '',
            h.status || ''
          ].join(','))
        ].join('\n');

        // Download CSV
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `CBHI_Hospitals_${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        this.showAlert('success', 'Export completed successfully');
      } catch (error) {
        console.error('Export error:', error);
        this.showAlert('failed', 'Failed to export data');
      }
    },

    // Pagination methods
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    // Delete hospital methods
    confirmDelete(hospital) {
      this.hospitalToDelete = hospital;
      this.resetDeleteModal();
      const modal = new bootstrap.Modal(document.getElementById('deleteConfirmationModal'));
      modal.show();
    },

    resetDeleteModal() {
      this.deleteConfirmationText = '';
      this.isDeleteConfirmed = false;
      this.deleting = false;
    },

    checkDeleteConfirmation() {
      this.isDeleteConfirmed = this.deleteConfirmationText === 'DELETE';
    },

    async deleteHospital() {
      if (!this.isDeleteConfirmed || this.deleting) return;

      this.deleting = true;

      try {
        const data = {
          function: "deleteHospital",
          hospitalId: this.hospitalToDelete.hospital_id
        };

        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          // Remove hospital from local arrays
          this.hospitals = this.hospitals.filter(h => h.hospital_id !== this.hospitalToDelete.hospital_id);
          this.filteredHospitals = this.filteredHospitals.filter(h => h.hospital_id !== this.hospitalToDelete.hospital_id);

          // Recalculate statistics
          this.calculateStatistics();

          // Close modal
          const modal = bootstrap.Modal.getInstance(document.getElementById('deleteConfirmationModal'));
          modal.hide();

          // Reset delete state
          this.hospitalToDelete = null;
          this.resetDeleteModal();

          // Show success message
          this.showAlert('success', `Hospital "${this.hospitalToDelete?.hospital_name || 'Hospital'}" has been deleted successfully.`);

          // If current page is empty after deletion, go to previous page
          if (this.paginatedHospitals.length === 0 && this.currentPage > 1) {
            this.currentPage--;
          }
        } else {
          this.showAlert('failed', response.data.message || 'Failed to delete hospital');
        }
      } catch (error) {
        console.error('Error deleting hospital:', error);
        this.showAlert('failed', error.message || 'Error deleting hospital');
      } finally {
        this.deleting = false;
      }
    }
  },

  // Cleanup timeout on component destroy
  beforeUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
};
</script>

<style scoped>
.spinner-border {
  width: 3rem;
  height: 3rem;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.search-box input {
  padding-right: 35px;
}

.hospital-name {
  font-size: 0.95rem;
  color: #495057;
}

.location-text {
  font-size: 0.875rem;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.modal-header.bg-primary {
  background-color: #5156be !important;
}

.contact-info {
  font-size: 0.85rem;
  line-height: 1.5;
}

.table-actions .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  cursor: pointer;
  user-select: none;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}

.avatar-title.bg-teal {
  background-color: #50a5f1 !important;
}

.avatar-title.bg-purple {
  background-color: #5b73e8 !important;
}

.dataTables_info {
  padding-top: 0.85rem;
  font-size: 0.875rem;
  color: #74788d;
}

.modal-body table td:first-child {
  width: 40%;
}

/* Custom scrollbar for table */
.table-responsive::-webkit-scrollbar {
  height: 8px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>